import React, { useState } from 'react';
import styles from '../styles/StaffDashboard.module.css';

const StaffDashboard = () => {
  const [photo, setPhoto] = useState<string | null>(null);
  const [rank, setRank] = useState('Associate Professor');
  const [articleTitle, setArticleTitle] = useState('');
  const [abstract, setAbstract] = useState('');
  const [journalType, setJournalType] = useState('');
  const [uploadOption, setUploadOption] = useState('');

  const publications = [
    { id: 1, title: "The Metaphysics of Truth in Postmodern Thought", journal: "Peer-Reviewed Journal", date: "2023-11-15", status: "Published" },
    { id: 2, title: "Ethical implications of All In Healthcare Diagnostics", journal: "Conference Proceedings", date: "2024-03-20", status: "Under Review" },
    { id: 3, title: "A Critical Analysis of Rawl's Theory of Justice", journal: "Book Chapter", date: "2023-09-01", status: "Published" },
    { id: 4, title: "Mind-Body Dualism in Contemporary Philosophy", journal: "Peer-Reviewed Journal", date: "2024-01-10", status: "Accepted" },
    { id: 5, title: "The Philosophy of Language and Its Impact on Communication", journal: "Monograph", date: "2022-07-22", status: "Published" },
    { id: 6, title: "Extremities and the Search for Meaning", journal: "Peer-Reviewed Journal", date: "2024-05-05", status: "Under Review" },
    { id: 7, title: "Plato's Allegory of the Cave: A Modern Interpretation", journal: "Conference Proceedings", date: "2023-04-12", status: "Published" },
    { id: 8, title: "The Problem of Evil in Analytical Philosophy", journal: "Peer-Reviewed Journal", date: "2024-06-01", status: "Accepted" }
  ];

  const handlePhotoUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (event) => {
        setPhoto(event.target?.result as string);
      };
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  return (
    <div className={styles['staff-dash-container']}><br/><br/><br/>
      <header className={styles['staff-dash-header']}>
        <h1>Department of Philosophy - Staff Dashboard</h1>
      </header>

      <div className={styles['staff-dash-profile-section']}>
        <div className={styles['staff-dash-card']}>
          <h2>Profile Overview</h2>
          <div className={styles['staff-dash-profile-content']}>
            <div className={styles['staff-dash-photo-upload']}>
              <div className={styles['staff-dash-avatar']}>
                {photo ? <img src={photo} alt="Profile" /> : <div className={styles['staff-dash-avatar-placeholder']} />}
                <label className={styles['staff-dash-upload-button']}>
                  Upload Photo
                  <input type="file" accept="image/*" onChange={handlePhotoUpload} hidden />
                </label>
              </div>
              <div className={styles['staff-dash-profile-info']}>
                <h3>Dr. Anya Okoro</h3>
                <p>Department of Philosophy</p>
                <p className={styles['staff-dash-update-date']}>Last updated: 2024-07-26</p>
              </div>
            </div>
          </div>
        </div>

        <div className={styles['staff-dash-card']}>
          <h2>Academic Rank</h2>
          <div className={styles['staff-dash-rank-section']}>
            <p>Current Rank</p>
            <div className={styles['staff-dash-current-rank']}>
              <h3>{rank}</h3>
              <button className={styles['staff-dash-update-button']}>Update Rank</button>
            </div>
          </div>
        </div>
      </div>

      <div className={styles['staff-dash-card']}>
        <h2>Upload New Article</h2>
        <div className={styles['staff-dash-upload-section']}>
          <div className={styles['staff-dash-form-group']}>
            <label>Article Title</label>
            <input 
              type="text" 
              value={articleTitle} 
              onChange={(e) => setArticleTitle(e.target.value)} 
              placeholder="The Ethics of Artificial Intelligence" 
            />
          </div>
          
          <div className={styles['staff-dash-form-group']}>
            <label>Abstract</label>
            <textarea 
              value={abstract} 
              onChange={(e) => setAbstract(e.target.value)} 
              placeholder="Provide a brief summary of your article..." 
              rows={4}
            />
          </div>
          
          <div className={styles['staff-dash-upload-options']}>
            <label>Upload Option</label>
            <div className={styles['staff-dash-option-buttons']}>
              <button 
                className={`${styles['staff-dash-option-button']} ${uploadOption === 'pdf' ? styles['staff-dash-active'] : ''}`}
                onClick={() => setUploadOption('pdf')}
              >
                Upload PDF
              </button>
              <button 
                className={`${styles['staff-dash-option-button']} ${uploadOption === 'link' ? styles['staff-dash-active'] : ''}`}
                onClick={() => setUploadOption('link')}
              >
                Provide Link
              </button>
            </div>
            
            {uploadOption === 'pdf' && (
              <div className={styles['staff-dash-file-upload']}>
                <input type="file" accept=".pdf" />
              </div>
            )}
            
            {uploadOption === 'link' && (
              <div className={styles['staff-dash-form-group']}>
                <input type="text" placeholder="Paste article link here..." />
              </div>
            )}
          </div>
          
          <div className={styles['staff-dash-form-group']}>
            <label>Journal Type</label>
            <select value={journalType} onChange={(e) => setJournalType(e.target.value)}>
              <option value="">Select publication type</option>
              <option value="Peer-Reviewed Journal">Peer-Reviewed Journal</option>
              <option value="Conference Proceedings">Conference Proceedings</option>
              <option value="Book Chapter">Book Chapter</option>
              <option value="Monograph">Monograph</option>
            </select>
          </div>
          
          <button className={styles['staff-dash-submit-button']}>Submit Article</button>
        </div>
      </div>

      <div className={styles['staff-dash-card']}>
        <h2>My Publications</h2>
        <div className={styles['staff-dash-publications-header']}>
          <input type="text" placeholder="Search by title..." />
          <select>
            <option value="">All Types</option>
            <option value="Peer-Reviewed Journal">Peer-Reviewed Journal</option>
            <option value="Conference Proceedings">Conference Proceedings</option>
            <option value="Book Chapter">Book Chapter</option>
            <option value="Monograph">Monograph</option>
          </select>
        </div>
        
        <div className={styles['staff-dash-table-container']}>
          <table>
            <thead>
              <tr>
                <th>Title</th>
                <th>Journal Type</th>
                <th>Date Published</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {publications.map((pub) => (
                <tr key={pub.id}>
                  <td>{pub.title}</td>
                  <td>{pub.journal}</td>
                  <td>{pub.date}</td>
                  <td>
                    <span className={`${styles['staff-dash-status-badge']} ${styles[`staff-dash-status-${pub.status.replace(/\s+/g, '-').toLowerCase()}`]}`}>
                      {pub.status}
                    </span>
                  </td>
                  <td>
                    <button className={styles['staff-dash-action-button']}>Edit</button>
                    <button className={`${styles['staff-dash-action-button']} ${styles['staff-dash-delete']}`}>Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      
      <footer className={styles['staff-dash-footer']}>
        <p>© Department of Philosophy. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default StaffDashboard;